import { useEffect } from 'react'
import { connectStateResults } from 'react-instantsearch-dom'
import { reportError } from 'utils/error'

export const SearchErrorCatcher = connectStateResults(({ error }: any) => {
  useEffect(() => {
    if (error?.name !== 'AlgoliaSearchError') return

    reportError(error, { severity: 'error', metaData: { info: `fetchData: ${error.message}` } })
  }, [error])

  return null
})
